import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserTokenListResponse } from './user-token-base.model';

@Injectable({
  providedIn: 'root'
})
export class UserTokenApi {
  #httpClient = inject(HttpClient);

  tokenList$() {
    return this.#httpClient.get<UserTokenListResponse>(`/api/user-token/list`);
  }
}
